module.exports = __webpack_public_path__ + "img/logo.c04dbed1.png";